import type { FaireThemeEntity } from "../../entity_types/theme";

export const elevated_occasion_wear_and_tailoring: FaireThemeEntity = {
  token: "elevated-occasion-wear-and-tailoring",
  type: "theme",
  name: "Elevated Occasion Wear & Tailoring",
  description: "Introduce a more formal aesthetic to your pop-up boutique with structured blazers and dressy silhouettes for social events.",
  teaser: "As a predicted clothing retailer that frequently stocks accessories like crossbody bags, adding formal apparel creates a complete outfit destination for your patrons.",
  detail: "This theme is supported by the multiple search queries for 'women's dressy dresses and blazers', 'womens formal dresses', and 'formal blazer women'.",
  bgColor: "#D4FFD4",
  tileBgColor: "#593c6b",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_vgq5x8ec86",
    "p_ggp73rpu8d",
    "p_keqgr868p3",
    "p_kxz6ptza2n",
    "p_yzssdmr9b9",
    "p_naxnq9wsnr",
    "p_3j9vp34anz",
    "p_be7e9t4urv",
    "p_3x7jurawxd",
    "p_ef5dx3smxy",
    "p_n6swtztaac",
    "p_87vtb36znv",
    "p_4a98ge5qxv",
    "p_uq548u6zz9",
    "p_fxu3q5cnut",
    "p_mg4yt9bgbr",
    "p_3maghfvneu",
    "p_s7p3cxhdhw",
    "p_gk6wdtetd6",
    "p_4akzcss44h",
    "p_bpu4kdr4s6",
    "p_u2wfxhgs92",
    "p_nrk8wr7wdq",
    "p_mbdtz46e22",
    "p_qv5ajws2wg",
    "p_fcbdc7hfqh",
    "p_5v2jah6dtc",
    "p_6a7s4jw94j",
    "p_nx7zdkdcrp",
    "p_49ncqfqzxp",
    "p_ebbamkd6hz",
    "p_gqcmb8cn6t",
    "p_f69nuz9cf3",
    "p_87ef6646pb",
    "p_3hpcueb3m9",
    "p_baztwggcve",
    "p_4zx3x5qhmt",
    "p_44m5eburmk",
    "p_22nnrrtvbx",
    "p_ctkolqalm6",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
